module.exports = __webpack_public_path__ + "img/pedaloWhite.cdf0cabc.svg";